module.exports = __webpack_public_path__ + "img/ro_ro.9624dc6b.png";